var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox-filter"},[_c('div',{class:_vm.main_class},[_c('q-checkbox',{attrs:{"dark":"","disable":_vm.disabled,"label":_vm.label},model:{value:(_vm.currentFilter),callback:function ($$v) {_vm.currentFilter=$$v},expression:"currentFilter"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }